import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderWorkersDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "get", // Change GET to POST
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/provider/GenerateProviderWorkersDocsReport`,
        params: {
          ...apiData,
          // status: apiData.status.replace(/\s+/g, "_"),
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id)
          ),
          provider_org_ids: JSON.stringify(
            apiData.provider_org_ids?.map((item) => item?.provider_org_id)
          ),
          worker_ids: JSON.stringify(apiData.worker_ids),
          document_ids: JSON.stringify(apiData.document_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };
